import { defineStore } from 'pinia'

export const useLabelsStore = defineStore('labels', {
    state: () => ({
        collections: {},
    }),
    getters: {},
    actions: {
        setCollection(payload) {
            if (Array.isArray(payload)) {
                payload.forEach((collection) => {
                    this.collections[collection.collectionName] = collection.labels
                })
            } else {
                this.collections[payload.collectionName] = payload.labels
            }
        },
        getLabel(payload) {
            if (!payload.collectionName) return payload.labelKey

            return returnCollection(this.collections[payload.collectionName][payload.labelKey], payload)
                ? returnLabel(this.collections[payload.collectionName][payload.labelKey], payload)
                : payload.emptyIfMissing
                  ? ''
                  : payload.labelKey
        },
        existLabel(payload) {
            return returnCollection(state.collections[payload.collectionName][payload.labelKey], payload)
                ? returnLabel(state.collections[payload.collectionName][payload.labelKey])
                : false
        },
    },
})

const returnLabel = (input, payload) => {
    if (input) {
        if (payload.params) {
            payload.params.forEach((param, i) => {
                input = input.replace(`{${i}}`, param)
            })
        }

        return input
    }

    if (payload.allowEmpty && input !== undefined) return input

    console.error('Missing label:', payload.collectionName + '.' + payload.labelKey)
    return input
}

const returnCollection = (input, payload) => {
    if (!input) console.error('Missing label-collection:', payload.collectionName)
    return input
}
